import { Box, VStack, Text, Image, Button } from '@chakra-ui/react';
import { Tooltip } from './ui/tooltip';
import { FiHome, FiBarChart2, FiMenu, FiBookOpen, FiFileText, FiRefreshCw, FiTrendingUp, FiClock } from 'react-icons/fi';
import { useLocation, Link } from 'react-router-dom';

function Sidebar({ ticker, isExpanded, setIsExpanded }) {
  const toggleSidebar = () => setIsExpanded(!isExpanded);
  const normalizedTicker = ticker ? ticker.toLowerCase() : ticker;
  const financialsPath = `/stock/${normalizedTicker}/financials/balance-sheet`;

  return (
    <Box
      position="fixed"
      top="0"
      bottom="0"
      left="0"
      bg="#071C33"
      borderRight="1px solid"
      borderColor="#123150"
      w={isExpanded ? "260px" : "60px"}
      transition="width 0.3s ease"
      willChange="width"
      overflow="hidden"
      display={{ base: "none", md: "flex" }}
      flexDirection="column"
      alignItems="center"
      zIndex="999"
      css={{ contain: "layout style" }}
    >
      {/* Header / Logo / Toggle */}
      <Box
        w="full"
        paddingY="2"
        paddingX="3"
        display="flex"
        justifyContent={isExpanded ? "space-between" : "center"}
        alignItems="center"
      >
        {isExpanded && (
          <Image
            src="/dcf_teacher_logo512.jpg"
            alt="DCF Teacher Logo"
            boxSize="40px"
            objectFit="contain"
          />
        )}

        <Button
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
          variant="ghost"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
        >
          <FiMenu />
        </Button>
      </Box>

      {/* Navigation Items */}
      <VStack
        spacing="4"
        align="center"
        mt="8"
        w="full"
      >
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}`} icon={FiHome} label="Home" isExpanded={isExpanded} />
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}/analysis`} icon={FiBarChart2} label="DCF Analysis" isExpanded={isExpanded} />
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}/reverse-dcf`} icon={FiRefreshCw} label="Reverse DCF" isExpanded={isExpanded} />
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}/charts`} icon={FiTrendingUp} label="Charts" isExpanded={isExpanded} />
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}/snapshot`} icon={FiClock} label="Snapshot" isExpanded={isExpanded} />
        <SidebarItem as={Link} to={financialsPath} icon={FiBookOpen} label="Financial Statements" isExpanded={isExpanded} activePrefix={`/stock/${normalizedTicker}/financials`} />
        <SidebarItem as={Link} to={`/stock/${normalizedTicker}/sec-filings`} icon={FiFileText} label="SEC Filings" isExpanded={isExpanded} />
      </VStack>
    </Box>
  );
}

// --- MODIFIED COMPONENT ---
function SidebarItem({ icon, label, isExpanded, as, to, activePrefix }) {
  // 2. Get the current location object
  const location = useLocation();

  // 3. Check if this link is the active one
  const isActive = activePrefix
    ? location.pathname.startsWith(activePrefix)
    : location.pathname === to;

  const activeBg = "#1769E8";
  const hoverBg = "whiteAlpha.200";
  const activeColor = "white";
  const textColor = "#D7E3F0";

  const content = (
    <Box
      as={as}
      to={to}
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="full"
      px={isExpanded ? "4" : "0"}
      py="2"
      bg={isActive ? activeBg : "transparent"}
      _hover={{
        bg: !isActive && hoverBg,
        cursor: "pointer"
      }}
      borderRadius="lg"
      mx={isExpanded ? "4" : "auto"}
    >
      <Box
        as={icon}
        fontSize="20px"
        color={isActive ? activeColor : textColor}
        mr={isExpanded ? "3" : "0"}
      />
      {isExpanded && (
        <Text
          fontSize="md"
          color={isActive ? activeColor : textColor}
          fontWeight={isActive ? "semibold" : "normal"}
          isTruncated
          w="full"
          whiteSpace="nowrap"
        >
          {label}
        </Text>
      )}
    </Box>
  );

  if (!isExpanded) {
    return (
      <Tooltip content={label} positioning={{ placement: "right" }}>
        {content}
      </Tooltip>
    );
  }

  return content;
}

export default Sidebar;
